import React, { useEffect } from "react";
import AppOverview from "../Components/AppOverview";
import BlogSlider from "../Components/BlogSlider";
import CallAction from "../Components/CallAction";
import ContactSection from "../Components/ContactSection";
import CookieNotice from "../Components/CookieNotice";
import CoreFeatures from "../Components/CoreFeatures";
import DownloadApp from "../Components/DownloadApp";
import Faq from "../Components/Faq";
import Funfact from "../Components/Funfact";
import Hero from "../Components/Hero";
import Integration from "../Components/Integration";
import MobileAppFeatures from "../Components/MobileAppFeatures";
import OurClients from "../Components/OurClients";
import ScreenShootSlider from "../Components/ScreenShootSlider";
import TestimonialSlider from "../Components/TestimonialSlider";
import WhatsBenifit from "../Components/WhatsBenifit";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero />
      <WhatsBenifit />
      <CoreFeatures />
      <Integration />
      <Funfact />
      <TestimonialSlider />
      <DownloadApp />
      <MobileAppFeatures />
      <AppOverview />
      <OurClients />
      <ScreenShootSlider
        galleryID="my-test-gallery"
        images={[
          {
            largeURL: "https://i.ibb.co/s6vyqz1/screenshot-1.png",
            thumbnailURL: "https://i.ibb.co/s6vyqz1/screenshot-1.png",
            width: 1200,
            height: 900,
          },
          {
            largeURL: "https://i.ibb.co/0JF69b1/screenshot-2.png",
            thumbnailURL: "https://i.ibb.co/0JF69b1/screenshot-2.png",
            width: 1200,
            height: 900,
          },
          {
            largeURL: "https://i.ibb.co/hXMPGfY/screenshot-3.png",
            thumbnailURL: "https://i.ibb.co/hXMPGfY/screenshot-3.png",
            width: 1200,
            height: 900,
          },
          {
            largeURL: "https://i.ibb.co/hXMPGfY/screenshot-3.png",
            thumbnailURL: "https://i.ibb.co/hXMPGfY/screenshot-3.png",
            width: 1200,
            height: 900,
          },
          {
            largeURL: "https://i.ibb.co/p2PnKVW/screenshot-5.png",
            thumbnailURL: "https://i.ibb.co/p2PnKVW/screenshot-5.png",
            width: 1200,
            height: 900,
          },
          {
            largeURL: "https://i.ibb.co/8jS9hQn/screenshot-6.png",
            thumbnailURL: "https://i.ibb.co/8jS9hQn/screenshot-6.png",
            width: 1200,
            height: 900,
          },
          {
            largeURL: "https://i.ibb.co/qMt6Y2s/screenshot-7.png",
            thumbnailURL: "https://i.ibb.co/qMt6Y2s/screenshot-7.png",
            width: 1200,
            height: 900,
          },
          {
            largeURL: "https://i.ibb.co/CHc4Wm8/screenshot-8.png",
            thumbnailURL: "https://i.ibb.co/CHc4Wm8/screenshot-8.png",
            width: 1200,
            height: 900,
          },
          {
            largeURL: "https://i.ibb.co/KwZHrCh/screenshot-9.png",
            thumbnailURL: "https://i.ibb.co/KwZHrCh/screenshot-9.png",
            width: 1200,
            height: 900,
          },
          {
            largeURL: "https://i.ibb.co/WpQbsmG/screenshot-10.png",
            thumbnailURL: "https://i.ibb.co/WpQbsmG/screenshot-10.png",
            width: 1200,
            height: 900,
          },
          {
            largeURL: "https://i.ibb.co/xDjdTg3/screenshot-11.png",
            thumbnailURL: "https://i.ibb.co/xDjdTg3/screenshot-11.png",
            width: 1200,
            height: 900,
          },
        ]}
      />
      <Faq />
      <CallAction />
      <BlogSlider />
      <ContactSection />
      <CookieNotice />
    </>
  );
};

export default Home;
